import React, { useEffect } from "react";
import "./App.css";
import { Routes, Route, Navigate, useLocation, useSearchParams } from "react-router-dom";
import {
  Authenticator,
  View,
  Text,
  Heading,
  useTheme,
  ThemeProvider,
} from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import { Amplify } from "aws-amplify";
import { signUp } from "aws-amplify/auth";
import LayoutApp from "./components/LayoutApp";
import { APP_NAME } from "./env";
import { salesConfig, plannerConfig } from "./config/pageConfigs";

const awsConfig = {
    "aws_project_region": "eu-central-1",
    "aws_cognito_region": "eu-central-1",
    "aws_cognito_identity_pool_id": "eu-central-1:90debe44-62bf-4542-a120-bad5625605b1",
    "aws_user_pools_id": "eu-central-1_NgcELPwyQ",
    "aws_user_pools_web_client_id": "3527o6i1nhsrj9ahtpp1ogas4t",
    "oauth": {},
    "aws_cognito_username_attributes": ["EMAIL"],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": ["EMAIL"],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": ["EMAIL"]
};

Amplify.configure(awsConfig);

function App({ signOut, user }) {
  const location = useLocation();
  const [searchParams] = useSearchParams();

  // Capture ?ref= parameter and persist to localStorage
  useEffect(() => {
    const ref = searchParams.get("ref");
    if (ref) {
      localStorage.setItem("signup_ref", ref);
    }
  }, [searchParams]);

  const currentConfig = location.pathname === "/planner" ? plannerConfig : salesConfig;

  useEffect(() => {
    document.title = "Netbits Agent Factory";
  }, [currentConfig.title]);

  // Custom sign-up service that includes custom:ref attribute
  const services = {
    async handleSignUp(formData) {
      const ref = localStorage.getItem("signup_ref") || "";
      const { username, password, options } = formData;
      return signUp({
        username,
        password,
        options: {
          ...options,
          userAttributes: {
            ...options?.userAttributes,
            "custom:ref": ref,
          },
        },
      });
    },
  };

  const components = {
    Header() {
      const { tokens } = useTheme();

      return (
        <View textAlign="center" padding={tokens.space.large}>
          <Heading
            level={2}
            style={{ color: "#333333", paddingTop: "48px" }}
            fontWeight={tokens.fontWeights.semibold}
            fontSize={tokens.fontSizes.xl}
          >
            Netbits Agent Factory
          </Heading>
        </View>
      );
    },

    Footer() {
      const { tokens } = useTheme();

      return (
        <View textAlign="center" style={{ padding: "0px", margin: "0px" }}>
          <Text
            style={{
              fontSize: "0.875rem",
              color: "#7F7F7F",
              padding: "16px 0px 8px 0px",
            }}
          >
            &copy;{new Date().getFullYear()}, Netbits. All rights reserved.
          </Text>
          <img
            src="/images/Powered-By_logo-horiz_RGB.png"
            width={160}
            alt="Powered By AWS"
          />
        </View>
      );
    },
  };

  return (
    <ThemeProvider>
      <Authenticator
        components={components}
        services={services}
        //hideSignUp
      >
        <Routes>
          <Route path="/" element={<LayoutApp pageConfig={salesConfig} />} />
          <Route path="/planner" element={<LayoutApp pageConfig={plannerConfig} />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Authenticator>
    </ThemeProvider>
  );
}

export default App;
